// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { DropCodeCellItem_TliFragmentDoc } from './components/DropCodeCell.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingScopeMetaQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  rpavId: Types.Scalars['ID']['input'];
}>;


export type ProductOfferingScopeMetaQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, name: string, bidPackages: Array<{ __typename?: 'BidPackage', id: string, costCodes: Array<{ __typename?: 'CostCode', id: string }>, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined }>, version: { __typename?: 'ReadyPlanAggregateVersion', id: string, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }>, programData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }>, coverAsset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, versionNotes?: string | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }> } };

export type ProductOfferingScopeMeta_BidPackageFragment = { __typename?: 'BidPackage', id: string, costCodes: Array<{ __typename?: 'CostCode', id: string }>, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined };

export type ProductOfferingScopePageQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TakeoffLineItemFilter>;
  subFilter?: Types.InputMaybe<Types.TakeoffLineItemFilter>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  order?: Types.InputMaybe<Array<Types.TakeoffLineItemOrder> | Types.TakeoffLineItemOrder>;
  rpavId: Types.Scalars['ID']['input'];
}>;


export type ProductOfferingScopePageQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', quantity?: number | null | undefined, totalCostInCents: number, changeType: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string, useQuantity: boolean }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, code: string, displayName: string }>, task?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, location: { __typename?: 'Location', id: string, displayLocationPath: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, number: string, name: string } }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, forCoveringTakeoffs: boolean, revision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean }, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } } | null | undefined } } | null | undefined, previous?: { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string }, task?: { __typename?: 'GlobalPlanTask', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, drop?: { __typename?: 'Drop', id: string } | null | undefined } | null | undefined, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined }>, groupTotals: Array<{ __typename?: 'TakeoffLineItemGroupTotal', groupId: string, materialsInGroup: number, tasksInGroup: number, tliIdsInGroup: Array<string>, tlisInGroup: number, displayName: string }> } };

export type ProductOfferingScopePage_TliFragment = { __typename?: 'TakeoffLineItem', quantity?: number | null | undefined, totalCostInCents: number, changeType: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string, useQuantity: boolean }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, code: string, displayName: string }>, task?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, location: { __typename?: 'Location', id: string, displayLocationPath: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, number: string, name: string } }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, forCoveringTakeoffs: boolean, revision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean }, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } } | null | undefined } } | null | undefined, previous?: { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string }, task?: { __typename?: 'GlobalPlanTask', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, drop?: { __typename?: 'Drop', id: string } | null | undefined } | null | undefined, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined };

export type ProductOfferingScopePage_PreviousTlivFragment = { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string }, task?: { __typename?: 'GlobalPlanTask', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, drop?: { __typename?: 'Drop', id: string } | null | undefined };

export type ProductOfferingScopePage_GroupTotalsFragment = { __typename?: 'TakeoffLineItemGroupTotal', groupId: string, materialsInGroup: number, tasksInGroup: number, tliIdsInGroup: Array<string>, tlisInGroup: number, displayName: string };

export type ProductOfferingScopeMeta_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }>, programData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }>, coverAsset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, versionNotes?: string | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }> };

export const ProductOfferingScopeMeta_BidPackageFragmentDoc = gql`
    fragment ProductOfferingScopeMeta_BidPackage on BidPackage {
  id
  costCodes {
    id
  }
  bidPackageGroup {
    id
  }
}
    `;
export const ProductOfferingScopePage_PreviousTlivFragmentDoc = gql`
    fragment ProductOfferingScopePage_PreviousTliv on TakeoffLineItemVersion {
  id
  quantity
  unitOfMeasure {
    id
  }
  materialVariant {
    id
  }
  location {
    id
  }
  task {
    id
  }
  options {
    id
  }
  drop {
    id
  }
}
    `;
export const ProductOfferingScopePage_TliFragmentDoc = gql`
    fragment ProductOfferingScopePage_TLI on TakeoffLineItem {
  ...Named
  quantity
  unitOfMeasure {
    id
    abbreviation
    useQuantity
  }
  options {
    id
    active
    code
    displayName
  }
  task {
    ...Named
  }
  location {
    id
    displayLocationPath
  }
  item {
    id
    fullCode
    costCode {
      id
    }
  }
  materialVariant {
    id
    code
  }
  preferredBidContractLineItem {
    id
    forCoveringTakeoffs
    revision {
      id
      bidContract {
        id
        isInternalEstimate
      }
      bidPackageVersion {
        id
        bidPackage {
          ...Named
          bidPackageGroup {
            id
          }
        }
      }
    }
  }
  totalCostInCents
  ...DropCodeCellItem_TLI
  changeType
  previous {
    ...ProductOfferingScopePage_PreviousTliv
  }
}
    ${NamedFragmentDoc}
${DropCodeCellItem_TliFragmentDoc}
${ProductOfferingScopePage_PreviousTlivFragmentDoc}`;
export const ProductOfferingScopePage_GroupTotalsFragmentDoc = gql`
    fragment ProductOfferingScopePage_GroupTotals on TakeoffLineItemGroupTotal {
  groupId
  materialsInGroup
  tasksInGroup
  tliIdsInGroup
  tlisInGroup
  displayName
}
    `;
export const ProductOfferingScopeMeta_ProductOfferingFragmentDoc = gql`
    fragment ProductOfferingScopeMeta_ProductOffering on ProductOffering {
  ...Named
  version {
    id
    status {
      code
    }
  }
  status {
    code
    name
  }
  options {
    id
    displayName
    active
    type {
      id
      isElevation
    }
    location {
      id
      name
    }
    order
  }
  programData {
    id
    bedrooms
    fullBaths
    sellableSqft
  }
  assets {
    id
    isCoverPhoto
    asset {
      id
      downloadUrl
    }
  }
  coverAsset {
    id
    downloadUrl
  }
  status {
    code
    name
  }
  aggregateVersions {
    id
    version
    displayVersion
    versionNotes
    status {
      code
      name
    }
  }
}
    ${NamedFragmentDoc}`;
export const ProductOfferingScopeMetaDocument = gql`
    query ProductOfferingScopeMeta($id: ID!, $rpavId: ID!) {
  productOffering(id: $id, versionId: $rpavId) {
    ...ProductOfferingScopeMeta_ProductOffering
    bidPackages {
      ...ProductOfferingScopeMeta_BidPackage
    }
  }
}
    ${ProductOfferingScopeMeta_ProductOfferingFragmentDoc}
${ProductOfferingScopeMeta_BidPackageFragmentDoc}`;

/**
 * __useProductOfferingScopeMetaQuery__
 *
 * To run a query within a React component, call `useProductOfferingScopeMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingScopeMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingScopeMetaQuery({
 *   variables: {
 *      id: // value for 'id'
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function useProductOfferingScopeMetaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables> & ({ variables: ProductOfferingScopeMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables>(ProductOfferingScopeMetaDocument, options);
      }
export function useProductOfferingScopeMetaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables>(ProductOfferingScopeMetaDocument, options);
        }
// @ts-ignore
export function useProductOfferingScopeMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables>;
export function useProductOfferingScopeMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingScopeMetaQuery | undefined, ProductOfferingScopeMetaQueryVariables>;
export function useProductOfferingScopeMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables>(ProductOfferingScopeMetaDocument, options);
        }
export type ProductOfferingScopeMetaQueryHookResult = ReturnType<typeof useProductOfferingScopeMetaQuery>;
export type ProductOfferingScopeMetaLazyQueryHookResult = ReturnType<typeof useProductOfferingScopeMetaLazyQuery>;
export type ProductOfferingScopeMetaSuspenseQueryHookResult = ReturnType<typeof useProductOfferingScopeMetaSuspenseQuery>;
export type ProductOfferingScopeMetaQueryResult = Apollo.QueryResult<ProductOfferingScopeMetaQuery, ProductOfferingScopeMetaQueryVariables>;
export const ProductOfferingScopePageDocument = gql`
    query ProductOfferingScopePage($filter: TakeoffLineItemFilter, $subFilter: TakeoffLineItemFilter, $first: Int, $offset: Int, $order: [TakeoffLineItemOrder!], $rpavId: ID!) {
  takeoffLineItemsPage(
    versionId: $rpavId
    filter: $filter
    subFilter: $subFilter
    first: $first
    offset: $offset
    order: $order
  ) {
    items {
      ...ProductOfferingScopePage_TLI
    }
    groupTotals {
      ...ProductOfferingScopePage_GroupTotals
    }
  }
}
    ${ProductOfferingScopePage_TliFragmentDoc}
${ProductOfferingScopePage_GroupTotalsFragmentDoc}`;

/**
 * __useProductOfferingScopePageQuery__
 *
 * To run a query within a React component, call `useProductOfferingScopePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingScopePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingScopePageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      subFilter: // value for 'subFilter'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function useProductOfferingScopePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables> & ({ variables: ProductOfferingScopePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables>(ProductOfferingScopePageDocument, options);
      }
export function useProductOfferingScopePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables>(ProductOfferingScopePageDocument, options);
        }
// @ts-ignore
export function useProductOfferingScopePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables>;
export function useProductOfferingScopePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingScopePageQuery | undefined, ProductOfferingScopePageQueryVariables>;
export function useProductOfferingScopePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables>(ProductOfferingScopePageDocument, options);
        }
export type ProductOfferingScopePageQueryHookResult = ReturnType<typeof useProductOfferingScopePageQuery>;
export type ProductOfferingScopePageLazyQueryHookResult = ReturnType<typeof useProductOfferingScopePageLazyQuery>;
export type ProductOfferingScopePageSuspenseQueryHookResult = ReturnType<typeof useProductOfferingScopePageSuspenseQuery>;
export type ProductOfferingScopePageQueryResult = Apollo.QueryResult<ProductOfferingScopePageQuery, ProductOfferingScopePageQueryVariables>;